module.exports = __webpack_public_path__ + "media/pyramidMinus.e6316d39.mp4";